<button pm-button data-test-id="proceed-button-element" [pmType]="'primary'" *ngIf="displayProceedButton$ | async" (click)="proceedService.proceed()">{{ 'bookingPage.proceedButton' | translate }}</button>
